module.exports = __webpack_public_path__ + "b6351cfbe9b24bc1c8aa9ed7dd8e3942.MP3";